import secureLocalStorageImport from 'react-secure-storage';

/**
 * `react-secure-storage` ships a CJS module that does `exports.default = new SecureLocalStorage()`.
 * Vite 8's dependency optimizer (Rolldown-based) does not always unwrap this nested `.default`
 * during dev, so the default import can resolve to `{ default: SecureLocalStorage }` instead of
 * the instance itself, causing `secureLocalStorage.getItem is not a function` at runtime.
 *
 * Normalize the import here so all call sites get a working instance regardless of how the
 * bundler happens to interop the module.
 */
type SecureLocalStorageInstance = typeof secureLocalStorageImport;

const secureLocalStorage: SecureLocalStorageInstance =
  (secureLocalStorageImport as unknown as { default?: SecureLocalStorageInstance })?.default ?? secureLocalStorageImport;

export default secureLocalStorage;
